<div class="toggle" (click)="toggleValue()" id="toggle{{ index }}">
  <input type="text" style="display: none" />
  <div class="toggle__circle" [@toggle]="value ? 'on' : 'off'">
    {{ toggleWithText ? (value ? "DA" : "NE") : "" }}
  </div>
</div>
